export default [
  {
    name: 'jobPosting',
    path: '',
    component: () => import('@/views/JobPostingList.vue'),
  },
  {
    name: 'jobPostingDetail',
    path: ':annoId',
    component: () => import('@/views/JobPostingDetail.vue'),
  },
];
